import { render, staticRenderFns } from "./Edifact.vue?vue&type=template&id=c144a716"
import script from "./Edifact.vue?vue&type=script&lang=js"
export * from "./Edifact.vue?vue&type=script&lang=js"
import style0 from "./Edifact.vue?vue&type=style&index=0&id=c144a716&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports